import { render } from "./ColleagueDepartmentDetails.vue?vue&type=template&id=1e0fd417&scoped=true"
import script from "./ColleagueDepartmentDetails.vue?vue&type=script&lang=js"
export * from "./ColleagueDepartmentDetails.vue?vue&type=script&lang=js"

import "./ColleagueDepartmentDetails.vue?vue&type=style&index=0&id=1e0fd417&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e0fd417"]])

export default __exports__